export default __webpack_public_path__ + "static/sneakers.en.cover-67309397c31d16e6012db6a5bf5a81c1.jpg";